import useDataLayerEvent from 'js/components/DataLayer/hooks/useDataLayerEvent';

function useOnMouseEnter(dataLayer, handler) {
  return useDataLayerEvent(dataLayer, 'mouseover', handler);
}

export default useOnMouseEnter;
